// import DateFoodMeal from './DateFoodMeal';

export default {
  // component: DateFoodMeal,
  component: load(() =>
    import(/* webpackChunkName: "Feed-Report-Assignment" */ "./DateFoodMeal")
  ),
  permissions: [
    "FeedingConsoleMenu/FeedingConsoleReport/ReportFoodProgramMenu",
  ],
  name: app.translate("آمار رزرو افراد"),
  icon: "calendar-range",
  drawer: true,
};
